<template>
  <v-row class="desposite-dashboadpage Liabilities-page">
    <v-col xs="8" md="8">
      <ul class="breadcrumbs-list">
        <a  @click="backButton"><li>Liabilities</li></a>
        <li>&nbsp;>&nbsp;Liabilities Dashboard</li>
      </ul>
      <div class="head-text">
        <h1>Liabilities Dashboard</h1>
      </div>
     
      <LiabilitiesTab />
    </v-col>  
    <v-col xs="4" md="4">
      <div class="right-sidetop-box">
        <div class="select-box">
          <v-card> 
            <v-select
              :items="member_items"
              :v-model="member_name"
              item-value="id"
              item-text="name"
              chips
              label="All Users"
              @change="refreshDashboard($event)"
            ></v-select>
          </v-card>  
        </div>
        <div class="add-btn" v-if="allow_user_activity =='yes'">
          <v-btn class="orange-btn btn" @click="subCategory">
            ADD NEW
          </v-btn>
        </div>  
      </div>
      <v-row v-if="show_graph_block">
        <v-col cols="12" sm="12">
          <v-card class="right-sidebox">
            <div cols="12" class="total-deposit-box" >
              <span>
                Total Liabilities as on {{currentDate | moment("DD MMM, Y")}}
              </span> 
              <p>
                <span>  &#8377;</span>
                {{total.toLocaleString()}}
              </p> 
            </div>
            <div id="chart">
              <!-- <apexchart type="donut" :options="chartOptions" :series="series"></apexchart> -->
              <apexchart type="pie" :options="chartOptions" :series="series" graphData></apexchart>
              <ul class="chart-listbox">
                <li class="first-li">
                   <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #FFC241"></span>
                    <p>Home Loan</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{home_loan}}</span>
                </li>
                 <li class="second-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #6378B0"></span>
                    <p>Personal Loan</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{personal_loan}}</span>
                </li>
                 <li class="third-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #CEB871"></span>
                    <p>Students Loan</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{student_loan}}</span>
                </li>
                <li class="third-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #5A28CD"></span>
                    <p>Car Loan</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{car_loan}}</span>
                </li>

                <li class="third-li">
                   <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #FA6D5C"></span>
                    <p>Policy Loan</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{policy_loan}}</span>
                </li>
                 <li class="third-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #D07908"></span>
                    <p>Overdraft</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{over_draft}}</span>
                </li>
                 <li class="third-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #E35FE3"></span>
                    <p>Consumer Loan</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{consumer_loan}}</span>
                </li> 
                <li class="third-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #7D7D7D"></span>
                    <p>Loan Against Property</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{loan_against_property}}</span>
                </li>
                <li class="third-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #50ABF2"></span>
                    <p>2-wheeler-Loan</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{two_wheeler_loan}}</span>
                </li>
                <li class="third-li">
                  <div class="chart-listbox-dotbox">
                    <span class="dots" style="background-color: #3D8AF7"></span>
                    <p>Credit Card Loan</p>
                  </div>
                   <span> <span class="rupee"> &#8377;</span> {{credit_card_loan}}</span>
                </li>
              </ul>
            </div>

            <div class="button-box">
              <v-btn class="btn download-btn" @click="downloadReport">
                <v-img
                max-height="20"
                max-width="16"
                :src="require('@/assets/images/download-icon.png')"
              >
              </v-img>
                DOWNLOAD
              </v-btn>
              <!-- <v-btn class="btn share-btn">
                 <v-img
                    max-height="20"
                    max-width="18"
                    :src="require('@/assets/images/share-icon.png')"
                  >
                </v-img>
                SHARE
              </v-btn> -->
              <v-menu
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="btn share-btn" v-bind="attrs" v-on="on">
                     <v-img
                        max-height="20"
                        max-width="18"
                        :src="require('@/assets/images/share-icon.png')"
                      >
                    </v-img>
                    SHARE
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <WhatsApp :url="share_report_url" scale="2"></WhatsApp>
                    </v-list-item-title>
                    <v-list-item-title>
                      <Telegram :url="share_report_url" scale="2"></Telegram>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

            </div>

          </v-card> 
        </v-col> 
      </v-row>
       <!-- <div v-if="!show_graph_block">
              <span>No data is available for choosen parameters.</span>
      </div>   -->
    </v-col>  
  </v-row>  
</template>
<script>
  import LiabilitiesTab from './LiabilitiesTab';
  import { GET_LIABILITY_FORM_DETAIL, GET_API, UPDATE_USER_DETAILS } from "../../store/actions.type";
  import ApiService from "../../api/api.service";
  import { isEmpty } from 'lodash';
  import { WhatsApp, Telegram } from 'vue-socialmedia-share';
  export default {
    components: {
      LiabilitiesTab,
      WhatsApp,
      Telegram,
    },
    data: () => ({
      member_items: [],
      member_name:'',
      three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
      edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
      delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
      currentDate: new Date().setDate(new Date().getDate()),
      series: [],
      chartOptions: {
        dataLabels: {
          formatter(val) {
            return [ val.toFixed() + '%']
          }
        },
        labels: ["Home Loan", "Personal Loan","Student Loan","Car Loan","Policy Loan","Overdraft","Consumer Loan","Loan Against Property","2-wheeler-Loan","Credit Card Loan"],
        colors: ['#FFC241', '#6378B0', '#CEB871','#5A28CD','#FA6D5C','#D07908','#E35FE3','#7D7D7D','#50ABF2','#3D8AF7'],
        chart: {
          type: 'pie',
          edrawOnParentResize: true,
        },
        responsive: [{
           breakpoint: undefined,
            options: {
            }
        }],
        legend: {
          position: 'bottom',
          customLegendItems: ['','','','','','','','','',''],
          markers: {
            width: 0,
            height: 0,
            strokeWidth: 0,
            strokeColor: '',
            fillColors: undefined,
            radius: 0,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
          },
    } 
  },
      total:'', 
      home_loan:'',
      personal_loan:'',
      student_loan:'',
      car_loan:'',
      policy_loan:'',
      over_draft:'',
      consumer_loan:'',
      two_wheeler_loan:'',
      credit_card_loan:'',
      loan_against_property:'',
      show_graph_block:true,
      memberId:'', 
      share_report_url:'',
      allow_user_activity:localStorage.getItem('allow_user_activity')
    }), 
    created(){

      this.refreshDashboard('');
      Fire.$on("updateLiabilityData", () => {
        this.graphData();
        this.shareLink();
      });
    },
   
    created(){
      this.refreshDashboard('');
      Fire.$on("updateLiabilityData", () => {
        this.graphData();
        this.shareLink();
      });
    },
      mounted(){
        this.refreshDashboard('');  
        Fire.$on("updateLiabilityData", () => {
          this.graphData();
          this.shareLink();
        });
        if(!isEmpty(this.$store.getters.getLiabilityFormDetail)) {
          this.graphData();
          this.shareLink();
        }
    },
    methods:{
      subCategory(){
         this.$router.push({ name: "liabilities-subcategory", params: { open_consent_exp_modal:'yes'}}).catch(()=>{});
      },
      backButton(){
        this.$router.push({ name: 'liabilities-subcategory'}).catch(()=>{});
      },
      graphData(){
        
          this.member_items = [];
          this.series = this.series.length == 0 ? this.series : [];
          let response = this.$store.getters.getLiabilityFormDetail;
          // if(response.consent_member_str !=''){
          //   swal.fire({
          //     title: '',
          //     text: 'Consent has been expired for the memeber '+response.consent_member_str+'. Please proceed to provide your consent. Your liability data will not be updated unless the consent is provided.',
          //     icon: 'warning',
          //     showCancelButton: false,
          //     confirmButtonColor: '#051d42',
          //     //cancelButtonColor: '#d33',
          //     confirmButtonText: 'Proceed',
          //     //cancelButtonText:'No'
          //   }).then((result) => {
          //       this.$router.push({ name: "liabilities-subcategory" , params: { open_consent_exp_modal:'yes'}}).catch(()=>{}); 
          //   })
          // }
          response.member_list.forEach(elementData => {
             
            this.member_items.push({'id':elementData.id,'name':elementData.name})

          });
          this.total =response.balaces_details.total;
          response.balaces_details.balances.forEach(balance_detail => {
              this.series.push(parseFloat(balance_detail.balance));
            });
           if (this.total == 0) {
                this.show_graph_block = false;
              }else{
                this.show_graph_block = true;
              }
          this.home_loan = this.series[0];
          this. personal_loan = this.series[1];
          this.student_loan = this.series[2]; 
          this.car_loan = this.series[3];

          this.policy_loan = this.series[4];
          this.over_draft = this.series[5];

          this.consumer_loan = this.series[6];

          this.loan_against_property = this.series[7];
          
          this.two_wheeler_loan = this.series[8];
          this.credit_card_loan = this.series[9];
      },
      refreshDashboard(event){
        this.$loading(true);
        this.memberId = event;
        let userData = [
          {key:'selected_value', value:event.toString()},
        ]
        this.$store.dispatch(UPDATE_USER_DETAILS,userData)
        let user_name =  this.$store.getters.getUserDetails.user_name;
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));

        this.$store
        .dispatch(GET_LIABILITY_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            user_name: user_name,
            member_id:event,
          },
          api: "get-liability-form-detail",
        })
        .then((response) => {
         
          Fire.$emit('updateLiabilityData');
          this.$loading(false);
        }).catch(() => {
          this.$loading(false);
        });
      },
      downloadReport(){
        window.open(this.$store.getters.getLiabilityFormDetail.pdf_url, '_blank');
      },
      shareLink(){
        this.share_report_url = this.$store.getters.getLiabilityFormDetail.pdf_url;
        return this.share_report_url;
      },
    } 
  }
</script>
